module.exports = __webpack_public_path__ + "fonts/YekanBakhFaNumBold.fbecc2e.ttf";